import { intersection, isArray } from "lodash";

const safeIntersection = (a, b) => {
  const aNew = a ? (isArray(a) ? a : [a]) : [];
  const bNew = b ? (isArray(b) ? b : [b]) : [];
  return intersection(aNew, bNew);
};

export const handleCountryFilter = (country, country_pop) => {
  if (country) {
    if (country_pop) {
      const both = safeIntersection(country, country_pop);
      return both && both.length ? both : "Invalid";
    } else {
      return country;
    }
  } else {
    return country_pop;
  }
};

export const countByValues = ["grant", "app", "pub", "family", "family_ext", "family_grant", "family_ext_grant"];
export const viewValues = ["family", "pub", "familyExt"];
export const countBy2View = cb => (cb ? {
  family: "family",
  family_ext: "familyExt",
  family_grant: "family",
  family_ext_grant: "familyExt",
  grant: "pub",
  app: "pub",
  pub: "pub"
}[cb] : "pub");
export const view2cardinalField = v => (v ? {
  family: "family_id",
  familyExt: "extended_family_id",
  pub: undefined
}[v] : undefined)